import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import queryString from 'query-string';

const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = fetchBaseQuery({
  baseUrl: '/',
  redirect: 'manual', // Отключаем автоматическое следование за редиректами
  paramsSerializer: (params) => queryString.stringify(params, { arrayFormat: 'none' }),
});

export const mainApi = createApi({
  reducerPath: 'mainApi',
  baseQuery: baseQuery,
  tagTypes: ['ColumnsState', 'CrsItem', 'PersonInRegistry'],
  endpoints: () => ({}),
});
